module.exports = __webpack_public_path__ + "img/google-play.d16830ca.svg";